<template>
  <article class="view-login bg-wave-gradient">
    <div class="site-wrapper flex-row flex-center-h flex-center-v">
      <div class="login-register flex-row flex-center-h">
        <section class="section--login flex-row flex-center-h flex-center-v">
          <header>
            <img role="img" aria-hidden="true" src="@/assets/svg/infovac-icon.svg" width="100px" />
            <h1>Connexion</h1>
          </header>

          <div class="flex-col flex-center" v-if="authToken && isLoading">
            <!-- By Sam Herbert (@sherb), for everyone. More @ http://goo.gl/7AJzbL -->
            <svg class="loader" width="44" height="44" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
              <g fill="none" fill-rule="evenodd" stroke-width="2">
                <circle cx="22" cy="22" r="1">
                  <animate attributeName="r" begin="0s" dur="1.8s" values="1; 20" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite" />
                  <animate attributeName="stroke-opacity" begin="0s" dur="1.8s" values="1; 0" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite" />
                </circle>
                <circle cx="22" cy="22" r="1">
                  <animate attributeName="r" begin="-0.9s" dur="1.8s" values="1; 20" calcMode="spline" keyTimes="0; 1" keySplines="0.165, 0.84, 0.44, 1" repeatCount="indefinite" />
                  <animate attributeName="stroke-opacity" begin="-0.9s" dur="1.8s" values="1; 0" calcMode="spline" keyTimes="0; 1" keySplines="0.3, 0.61, 0.355, 1" repeatCount="indefinite" />
                </circle>
              </g>
            </svg>

            <p class="hint">Veuillez patienter…</p>
          </div>

          <div v-if="!authToken || authError">
            <p class="text-center" style="font-size: 1.0875rem;">
              Connectez-vous à la plateforme <br />
              <strong><a :href="remoteLoginUrl">depuis le site infovac.fr</a></strong>
            </p>
            <p class="text-center" v-if="authError"><a href="mailto:support@infovac.crossdoc.fr">Contactez-nous</a> si vous rencontrez des difficultés à vous connecter.</p>
          </div>
        </section>
      </div>
    </div>
  </article>
</template>

<style lang="scss" scoped>
@import "src/scss/login.scss";
</style>

<script>
import { HTTP } from "../http-common";

export default {
  name: "login",

  data: function() {
    return {
      authError: false,
      isLoading: false,
      authToken: "",
      redirectURL: "",
      remoteLoginUrl: process.env.VUE_APP_REMOTE_LOGIN_URL,
    };
  },

  computed: {
    // Utilisateur connecté ?
    isLoggedIn: function() {
      return !!this.$store.state.userToken && !!this.$store.state.userData;
    },
  },

  methods: {
    // Connexion de l’utilisateur
    loginUser: async function() {
      console.log("loginUser");

      // clear dashboard filters for the session
      await this.$store.dispatch("STORE_DASHBOARD_FILTERS", "");

      return this.$store
        .dispatch("USER_LOGIN")
        .then(async (response) => {
          // User logged in, redirect to dashboard or to previous URL?
          const storedRedirectUrl = await this.$localStorage.get("redirectURL", "");
          console.log("USER_LOGIN storedRedirectUrl?", storedRedirectUrl);

          if (storedRedirectUrl) {
            console.log("should redirect", storedRedirectUrl);

            try {
              await this.$router.push(storedRedirectUrl);
              this.$localStorage.remove("redirectURL");
            } catch (e) {
              // NavigationDuplicated or guard rejection — fall back to dashboard
              this.$localStorage.remove("redirectURL");
              this.$router.push("/dashboard");
            }
          } else {
            this.$router.push("/dashboard");
          }
        })
        .catch((error) => {
          console.log("loginUser error", error);

          return this.$toasted.global.appError({
            message: '<strong>Erreur d’authentification</strong>, accédez à votre compte <a href="https://infovac.fr">infovac.fr</a>, rubrique <strong>"Question aux experts"</strong> pour vous connecter.',
          });
        });
    },

    // Authentification et Connexion de l'utilisateur
    signinUser: function() {
      console.log("signinUser");
      this.isLoading = true;

      this.$store
        .dispatch("AUTH_REQUEST", this.authToken)
        .then(async () => {
          this.$toasted.clear();
          this.isLoading = false;

          // Authorization Header (JWT)
          // (Si un token est déjà enregistré en localStorage, il est passé à chaque requête.)
          // -> L'authentification (AUTH_REQUEST) s'est déroulée avec succès : on ajoute le token à toutes les requêtes :
          HTTP.defaults.headers.common.Authorization = "Bearer " + this.$store.state.userToken;

          // Connexion distante
          await this.loginUser();
        })
        .catch((error) => {
          // Authentification error (invalid token, …)
          this.isLoading = false;
          this.authError = true;
          this.$toasted.clear();

          console.log("signinUser error", error);
          const errorStatus = error?.status;
          const errorMessage = error?.data?.payload?.error;
          console.log("error?", errorStatus, errorMessage);

          // Forbidden
          if (errorStatus === 403) {
            return this.$toasted.global.appError({
              message: '<strong>Connexion impossible</strong> : vous devez spécifier un <strong>numéro ADELI ou RPPS</strong> sur <a href="https://infovac.fr/mon-compte/">votre compte infovac.fr</a>, rubrique <strong>"Modifier mes informations"</strong>',
            });
          }
          // Missing required field
          else if (errorStatus === 422 && errorMessage === "required-field") {
            return this.$toasted.global.appError({
              message: '<strong>Connexion impossible</strong> : Il manque des informations nécessaires sur votre compte, veuillez <a href="mailto:support@infovac.crossdoc.fr">nous contacter</a>.',
            });
          }
          // Invalid email
          else if (errorStatus === 422 && errorMessage === "invalid-email") {
            return this.$toasted.global.appError({
              message: '<strong>Connexion impossible</strong> : Votre adresse e-mail est invalide, veuillez vérifier <a href="https://infovac.fr/mon-compte/">votre compte infovac.fr</a>',
            });
          }
          // Email exists
          else if (errorStatus === 409 && errorMessage === "email-exists") {
            return this.$toasted.global.appError({
              message: '<strong>Connexion impossible</strong> : Cette adresse e-mail est déjà utilisée, veuillez <a href="mailto:support@infovac.crossdoc.fr">nous contacter</a>.',
            });
          }
          // Other auth error
          else {
            return this.$toasted.global.appError({
              message: '<strong>Erreur d’authentification</strong>, accédez à <a href="https://infovac.fr/mon-compte/">votre compte infovac.fr</a>, rubrique <strong>"Question aux experts"</strong> pour vous connecter.',
            });
          }
        });
    },

    // Logout
    signOut: async function() {
      console.log("signing out…");
      await this.$store.dispatch("AUTH_LOGOUT");
    },
  },

  async mounted() {
    /*
			If there's an auth token (from a magic link)
			- logout
			- sign-in (get access tfoken)
			- then login (get user data)

			If there's no token provided but the user is logged-in; goto dashboard.
		*/

    // Get auth token from magic link
    this.authToken = this.$route?.query?.token;

    // Redirection?
    const queryRedirectUrl = this.$route.query.redirect || "";
    if (queryRedirectUrl) {
      this.redirectURL = queryRedirectUrl;
      this.$localStorage.set("redirectURL", queryRedirectUrl);
    }

    if (this.authToken) {
      // sign out (clear auth details)
      await this.signOut();
      // then sign in
      await this.signinUser();
      //
    } else if (this.isLoggedIn) {
      // redirect to dashboard
      this.$router.push("/dashboard");
    } else if (!this.isLoggedIn && !this.authToken) {
      // redirect to login on website
      console.log("this.remoteLoginUrl", this.remoteLoginUrl);
      setTimeout(() => (window.location.href = this.remoteLoginUrl), 100);
    }
  },
};
</script>
